<template>
  <div>
    <page-header title="ساخت محصول جدید"></page-header>

    <crud-generator :fields="fields" @submit="submit" name="products">
      <specification-selector
          @specificationsUpdated="specificationsUpdated"
      ></specification-selector>
    </crud-generator>
  </div>
</template>

<script>
import PageHeader from "@/components/General/PageHeader";
import CrudGenerator from "@/components/General/CrudGenerator";
import SpecificationSelector from "@/components/Product/SpecificationSelector";

export default {
  name: "CreateProduct",

  components: {SpecificationSelector, CrudGenerator, PageHeader},

  data() {
    return {
      fields: [],
      allCategories: null,
      selectedSpecifications: [],
    }
  },

  mounted() {
    this.getAllCategories()
  },

  methods: {
    getAllCategories() {
      this.$store.dispatch("getCategoriesWithoutChild")
      .then((res) => {
        this.allCategories = res.data
        this.fillFields()
      })
    },

    fillFields() {
      this.fields = [
        {
          name: 'fa_name',
          label: 'نام',
          cols: 6,
          type: 'text',
          direction: 'rtl',
        },
        {
          name: 'fa_subtitle',
          label: 'زیرعنوان',
          cols: 6,
          type: 'text',
          direction: 'rtl',
        },
        {
          name: 'fa_short_description',
          label: 'توضیح کوتاه',
          cols: 12,
          type: 'text',
          direction: 'rtl'
        },
        {
          name: 'fa_description',
          label: 'توضیحات',
          cols: 12,
          type: 'ckeditor',
          direction: 'rtl'
        },
        {
          name: 'fa_meta_title',
          label: 'عنوان متا',
          cols: 6,
          type: 'text',
          direction: 'rtl'
        },
        {
          name: 'fa_meta_keywords',
          label: 'کلیدواژه های متا',
          cols: 6,
          type: 'text',
          direction: 'rtl'
        },
        {
          name: 'fa_meta_descriptions',
          label: 'توضیحات متا',
          cols: 12,
          type: 'text',
          direction: 'rtl'
        },

        {
          name: 'en_name',
          label: 'Name',
          cols: 6,
          type: 'text',
          direction: 'ltr',
        },
        {
          name: 'en_subtitle',
          label: 'Subtitle',
          cols: 6,
          type: 'text',
          direction: 'ltr',
        },
        {
          name: 'en_short_description',
          label: 'Short Description',
          cols: 12,
          type: 'text',
          direction: 'ltr'
        },
        {
          name: 'en_description',
          label: 'Description',
          cols: 12,
          type: 'text',
          direction: 'ltr'
        },
        {
          name: 'en_meta_title',
          label: 'Meta Title',
          cols: 6,
          type: 'text',
          direction: 'ltr'
        },
        {
          name: 'en_meta_keywords',
          label: 'Meta Keywords',
          cols: 6,
          type: 'text',
          direction: 'ltr'
        },
        {
          name: 'en_meta_descriptions',
          label: 'Meta Description',
          cols: 12,
          type: 'text',
          direction: 'ltr'
        },
        {
          'type': 'row',
          'name': 'row-right',
          'cols': 8,
          'fields': [
            {
              name: 'category_id',
              label: 'دسته بندی',
              cols: 6,
              type: 'select',
              select_items: this.allCategories,
              select_value: 'id',
              select_text: 'fa_name',
            },
            {
              name: 'article_number',
              label: 'کد محصول',
              cols: 6,
              type: 'text',
              direction: 'ltr',
            },
            {
              cols: 12,
              type: 'text',
              direction: 'ltr',
              name: 'price',
              label: 'قیمت',
            },
          ]
        },
        {
          'type': 'row',
          'name': 'row-left',
          'cols': 4,
          'fields': [
            {
              name: 'image',
              label: 'تصویر',
              cols: 12,
              type: 'image',
            },
          ]
        },
      ]
    },

    submit(values) {
      values['specifications'] = this.selectedSpecifications
      this.$store.dispatch("createProduct", values)
          .then(() => {
            this.$router.push('/products')
          })
    },

    specificationsUpdated(values) {
      this.selectedSpecifications = values
    }
  }
}
</script>

<style scoped>

</style>